import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";

import Header from "../components/Header";

import Footer from "../components/Footer";

import rocket from "../assets/images/rocket.png";

import banner1 from "../assets/images/banner1.png";
import banner2 from "../assets/images/banner2.png";
import banner3 from "../assets/images/banner3.png";
import banner4 from "../assets/images/banner4.png";

import talent1 from "../assets/images/talent1.png";
import talent2 from "../assets/images/talent2.png";
import talent3 from "../assets/images/talent3.png";
import talent4 from "../assets/images/talent4.png";


import person1 from "../assets/images/person4.png";
import person2 from "../assets/images/person5.png";
import person3 from "../assets/images/person6.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import design from "../assets/images/design.png";
import decoration from "../assets/images/decoration.png";

import { useTranslation } from "react-i18next";
import whoAreWeImg from "../assets/images/whoAreWeImg.png";
import { MdArrowOutward } from "react-icons/md";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { FaLocationDot } from "react-icons/fa6";
import { FaEnvelope } from "react-icons/fa";
import { MdCall } from "react-icons/md";
import { Form, InputGroup } from "react-bootstrap";
import ApiService from "../services/ApiService";
import { toast } from "react-toastify";
import OurTalents from "../components/Company/OurTalents";
import flag from "../assets/images/UAE flag.jpeg";
import HowItWorks from "../components/Company/HowItWorks";

const HomePage = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [homeData, setHomeData] = useState({});
  const [refresh, setrefresh] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const { t, i18n } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    position: "",
    phone: "",
    company_name: "",
  });
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    message: "",
    position: "",
    phone: "",
    company_name: "",
  });

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const [activeTab, setActiveTab] = useState("Web developer");

  const tabs = ["Design", "Development", "Marketing", "AI", "Consultancy"];
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const navigate = useNavigate();
  const [scrollX, setScrollX] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const moveX = scrollPosition * 0.5;
      setScrollX(moveX);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const svgRef = useRef(null);
  const pathRef = useRef(null);

  useEffect(() => {
    const svg = svgRef.current;
    const path = pathRef.current;

    if (!svg || !path) return;

    const scroll = () => {
      const distance = window.scrollY;
      const totalDistance = svg.clientHeight - window.innerHeight;
      console.log(totalDistance);
      const percentage = distance / totalDistance;
      const pathLength = path.getTotalLength();

      path.style.strokeDasharray = `${pathLength}`;
      path.style.strokeDashoffset = `${pathLength * (1 - percentage)}`;
    };

    scroll();
    window.addEventListener("scroll", scroll);

    return () => {
      window.removeEventListener("scroll", scroll);
    };
  }, []);

  useEffect(() => {
    const currentLang = i18n.language;
    const direction = currentLang === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", direction);
    document.documentElement.setAttribute("lang", currentLang);
  }, [i18n.language]);


  console.log("home data----", homeData);

  const filteredTalents = activeTab?.talents || [];

  // Ensure we have at least 4 talent items for the slider
  const getDisplayTalents = () => {
    if (filteredTalents.length === 0) return [];

    let displayTalents = [...filteredTalents];
    while (displayTalents.length < 4) {
      displayTalents = [...displayTalents, ...filteredTalents];
    }
    return displayTalents.slice(0, 4);
  };

  const displayTalents = getDisplayTalents();
  console.log("displayTalents", displayTalents);
  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {
      name: formData.name ? "" : "Name is required",
      email: formData.email ? "" : "Email is required",
      message: formData.message ? "" : "Message is required",
      position: "",
      phone: formData.phone ? "" : "Phone number is required",
      company_name: "",
    };

    setErrors(newErrors);

    const hasErrors = Object.values(newErrors).some((error) => error !== "");
    if (hasErrors) return;

    try {
      const response = await ApiService.request({
        method: "POST",
        url: "/contactUs",
        headers: {
          Accept: "application/json",
          Language: "en",
        },
        data: {
          name: formData.name,
          email: formData.email,
          message: formData.message,
          phone: formData.phone.startsWith("0")
            ? "971" + formData.phone.substring(1)
            : "971" + formData.phone,
          company_name: formData.company_name,
          position: formData.position,
        },
      });

      const data = response.data;

      if (data.status) {
        toast.success(data.message);
        setShowPopup(true);
        setFormData({
          name: "",
          email: "",
          phone: "",
          company_name: "",
          position: "",
          message: "",
        });
        setErrors({
          name: "",
          email: "",
          phone: "",
          company_name: "",
          position: "",
          message: "",
        });
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log("Error on Contact Us Submit: ", error);
      toast.error("Something went wrong. Please try again.");
    }
  };
  const onClose = () => {
    setShowPopup(false);
  };
  const fetchHome = async (page) => {
    setIsLoading(true);
    try {
      const response = await ApiService.request({
        method: "GET",
        url: `/getHome`,
      });
      const data = response.data;
      // console.log("resp", data.data.skills[0].skill_title);
      setHomeData(data.data);
      if (data?.skills?.length > 0) {
        setActiveTab(data.skills[0].skill_title);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    console.log("active", activeTab);
    fetchHome();
    if (homeData?.skills?.length > 0) {
      console.log("issnfenk", homeData.skills[0].skill_title);
      setActiveTab(homeData.skills[0].skill_title);
    }
  }, [refresh]);
  const isRTL = i18n.language === "ar";
  return (
    <div className=" layout-wrapper ">
      <div
        className=" left-strip"
        style={{
          marginLeft: isRTL ? "0" : "1%",
          marginRight: isRTL ? "1%" : "0",
        }}
      >
        {[...Array(25)].map((_, i) => (
          <img
            key={i}
            src={decoration}
            alt="Decoration"
            className=" strip-icon"
          />
        ))}
      </div>
      <div
        className=" main-bg"
        style={{
          minHeight: "100vh",
        }}
      >
        <Header />
        {/* Banner Sec */}
        <div className=" header-banner" id="home">
          <div
            className=" container-fluid banner-txt"
            style={{ paddingTop: "140px" }}
          >
            <h1
              className={`text-center fw-bold res-size ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              style={{
                fontSize: "70px",
                fontWeight: "400",
              }}
            >
              {t("h_main_title.part1")}{" "}
              {/* <br
                className={`${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"} break`}
              />
               */}
              <img
                src={rocket}
                className="ms-2 rocket-animation"
                style={{ width: "35px", fontFamily: "auto" }}
                alt="rocket"
              />
            </h1>
            <p
              className={`text-center fw-bold p-size ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              style={{ fontWeight: 400 }}
            >
              {t("h_main_second_line.part1")}
              <br
                className={`${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"} break`}
              />
              {t("h_main_second_line.part2")}
            </p>
            <div
              className={`banner-btn d-flex flex-wrap justify-content-center align-items-center gap-3 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
            >
              <Link
                to={"/company"}
                className={`btn btn-base me-2 mt-3 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                style={{
                  minWidth: "180px",
                  whiteSpace: "nowrap",
                  height: "48px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {t("h_hire_button")} <MdArrowOutward fontSize={20} />
              </Link>

              <Link
                to={"/talent/register"}
                className={`btn btn-op-base fw-bold mt-3 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                style={{
                  minWidth: "180px",
                  whiteSpace: "nowrap",
                  height: "48px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {t("h_become_button")} <MdArrowOutward fontSize={20} />
              </Link>
            </div>
          </div>

          <div className="inter-font d-flex flex-wrap justify-content-center align-items-center mt-5 gap-2 gap-md-3">
            {[banner1, banner2, banner3, banner4].map((banner, index) => (
              <div
                key={index}
                className="inter-font p-1 p-md-2 position-relative"
                style={{ maxWidth: "295px", width: "45%" }}
              >
                <div
                  className="position-relative w-100 rounded-4 overflow-hidden"
                  style={{ borderRadius: "16px" }}
                >
                  <img
                    src={banner}
                    className="inter-font img-fluid w-100"
                    alt={`Banner ${index + 1}`}
                    style={{ display: "block", height: "300px", objectFit: "cover" }}
                  />
                  {/* Gradient Overlay */}
                  <div
                    className="position-absolute bottom-0 start-0 w-100"
                    style={{
                      height: "40%", 
                      background: "linear-gradient(to top, rgba(255, 107, 53, 0.5), transparent)",
                      pointerEvents: "none",
                    }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Who Are We */}
      <div
        className={`border-layer1 container rounded-5 bg-white ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
        id="about"
        style={{ borderRadius: "16px" }}
      >
        <div
          className={`top border-layer2 p-5 rounded-5 position-relative pt-5 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
          style={{ borderRadius: "16px" }}
        >
          <div
            className={`text-start ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
          >
            <h1
              className={`fw-normal ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              style={{ fontSize: "50px" }}
            >
              {t("h_s2_title")}
            </h1>
          </div>
          <div
            className={`row my-5  justify-content-center ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
            data-aos="zoom-out"
          >
            {/* <div className="dishcek-font col-md-6 col-sm-12"> */}
            <div
              className={`d-flex justify-contnet-center ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              style={{ maxWidth: "584px", maxHeight: "541px" }}
            >
              <img
                src={whoAreWeImg}
                className={`rounded-5 whoAreWe-img-size ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                style={{ maxWidth: "584px", maxHeight: "541px" }}
              />
            </div>
            {/* </div> */}
            <div
              className={`col-md-6 col-sm-12 d-flex align-items-center ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
            >
              <div
                className={`fw-normal ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              >
                <p
                  className={`mt-4 p-size fw-normal ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                  style={{
                    fontSize: "18px",
                  }}
                >
                  {/* We are a team of passionate innovators, designers, and
                  strategists committed to helping businesses grow and succeed.
                  With years of industry experience, we blend creativity with
                  technology to deliver solutions that truly make a difference
                  process. */}
                  {t("h_s2_des1")}
                </p>
                <p
                  className={`p-size fw-normal ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                  style={{
                    fontSize: "18px",
                  }}
                >
                  {/* The point of using Lorem Ipsum is that it has a more-or-less
                  normal distribution */}
                  {t("h_s2_des2")}
                </p>
                <button
                  className={`btn btn-base fw-bold me-2 mt-3 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                  onClick={() => navigate("/company")}
                >
                  {t("h_hire_button")} <MdArrowOutward fontSize={20} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Talents */}

      <OurTalents />

      <HowItWorks />
      {/* FAQs */}
      <div
        className={`container top rounded-5 faq ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
        id="faq"
        data-aos="zoom-in"
        style={{
          backgroundColor: "#E98266",
          // height: "690px",
        }}
      >
        <div
          className={`row p-3 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
        >
          <div
            className={`col-md-5 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
          >
            <div
              className={` text-white ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
            >
              <h1
                className={`fw-normal m-3 faq-heading ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                style={{
                  fontSize: "50px",
                }}
              >
                {t("h_title_faq")}
              </h1>
            </div>
          </div>
          <div
            className={`col-md-7 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
          >
            <div
              className={`bg-white main-faq p-3 p-md-5 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              style={{
                maxWidth: "725px",
                padding: "50px",
                borderRadius: "40px",
              }}
            >
              <div
                className={`accordion border-bottom-0 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                style={{ border: "1.5px solid", direction: i18n.language === "ar" ? "rtl" : "ltr" }}
              >
                {homeData?.faqs?.length > 0 &&
                  homeData.faqs.map((faq, index) => (
                    <div
                      key={index}
                      className={`mb-3 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                      style={{ borderBottom: "1.5px solid" }}
                    >
                      <button
                        className={`d-flex justify-content-between align-items-center w-100 p-3 bg-transparent border-0 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                        onClick={() => toggleFAQ(index)}
                        style={{
                          cursor: "pointer",
                          outline: "none",
                          backgroundColor:
                            activeIndex === index
                              ? "rgba(65, 19, 24, 0.05)"
                              : "transparent",
                        }}
                      >
                        <h5
                          className={`mb-0 text-start fw-normal text-dark ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                          style={{ fontSize: "1rem" }}
                        >
                          {index + 1}. {i18n.language === "ar" ? faq.question_ar : faq.question}
                        </h5>
                        {activeIndex === index ? (
                          <FiChevronUp size={20} />
                        ) : (
                          <FiChevronDown size={20} />
                        )}
                      </button>

                      {activeIndex === index && (
                        <div
                          className={`p-3 pt-0 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                        >
                          <p
                            style={{
                              color: "#555",
                              fontWeight: "300",
                              fontSize: "0.95rem",
                            }}
                          >
                            {i18n.language === "ar" ? faq.answer_ar : faq.answer }
                          </p>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Get In Touch */}
      <div
        className={`container top ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
        id="contact"
        data-aos="zoom-in"
      >
        <div
          className={`row ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
        >
          <div
            className={`col-md-4 left-space ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
          >
            <h1
              className={`fw-bolder ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
            >
              {t("h_s5_title")}
            </h1>
            <ul
              className={`list-unstyled ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
            >
              <li>
                <FaLocationDot fontSize={17} />
                <span
                  className={`ms-2 fw-bolder me-2 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                >
                  {t("h_s5_loc")}
                </span>
              </li>
              <li
                className={`my-2 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              >
                <FaEnvelope fontSize={17} />
                <a
                  href="mailto:info@nahham.ae"
                  className={`ms-2 fw-bolder me-2 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  info@nahham.ae
                </a>
              </li>
              <li>
                <MdCall fontSize={20} />
                <a
                  href="https://wa.me/971543655595"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`ms-1 fw-bolder me-2 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    direction: "ltr",
                    unicodeBidi: "isolate",
                  }}
                >
                  (+971) 54 365 5595
                </a>
              </li>
            </ul>
          </div>
          <div
            className={`col-md-8 left-space ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
          >
            <Form
              className={`bg-white custom-form ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              style={{ borderRadius: "40px", padding: "30px" }}
            >
              <Form.Group
                className={`mb-3 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              >
                <Form.Label>
                  <strong
                    className={`fw-normal ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                  >
                    {t("h_text3")} <span className="text-danger">*</span>
                  </strong>
                </Form.Label>
                {/* <Form.Control
                  type="text"
                  placeholder="Name...."
                  className="dishcek-font  rounded-2 bg-light border shadow-sm"
                /> */}
                <Form.Control
                  type="text"
                  placeholder={`${t("h_text3")}...`}
                  className={`rounded-2 bg-light border shadow-sm fw-normal ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                  value={formData.name}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormData({ ...formData, name: value });

                    // Clear error if valid
                    if (value.trim() !== "") {
                      setErrors((prev) => ({ ...prev, name: "" }));
                    }
                  }}
                  isInvalid={!!errors.name}
                  style={{
                    fontWeight: "400",
                  }}
                />
                {errors.name && (
                  <div className="text-danger mt-1">{errors.name}</div>
                )}
              </Form.Group>

              <Form.Group
                className={`fw-normal mb-3 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              >
                <Form.Label>
                  <strong className="fw-normal">
                    {t("h_text4")} <span className="text-danger">*</span>
                  </strong>
                </Form.Label>
                {/* <Form.Control
                  type="email"
                  placeholder="Email..."
                  className="dishcek-font  rounded-2 bg-light border shadow-sm"
                /> */}
                <Form.Control
                  type="email"
                  placeholder={`${t("h_text4")}...`}
                  className={`rounded-2 bg-light border shadow-sm fw-normal ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                  value={formData.email}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormData({ ...formData, email: value });
                    if (value.trim() !== "") {
                      setErrors((prev) => ({ ...prev, email: "" }));
                    }
                  }}
                  isInvalid={!!errors.email}
                  style={{
                    fontWeight: "400",
                  }}
                />
                {errors.email && (
                  <div className="text-danger mt-1">{errors.email}</div>
                )}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  <strong className="fw-normal">
                    {t("h_text5")} <span className="text-danger">*</span>
                  </strong>
                </Form.Label>

                <InputGroup
                  style={{
                    direction: "ltr",
                    unicodeBidi: "isolate",
                  }}
                >
                  {/* UAE Flag + Code */}
                  <InputGroup.Text className="bg-light border shadow-sm">
                    <img
                      src={flag} // replace with your actual flag image path
                      alt="UAE"
                      style={{
                        width: "20px",
                        height: "14px",
                        marginRight: "6px",
                      }}
                    />
                    (+971)
                  </InputGroup.Text>

                  {/* Phone Input */}
                  <Form.Control
                    type="text"
                    placeholder="52 123 4567"
                    value={formData.phone}
                    onChange={(e) => {
                      let value = e.target.value.replace(/\D/g, ""); // only digits

                      // check if starts with 0
                      const maxLength = value.startsWith("0") ? 10 : 9;

                      if (value.length <= maxLength) {
                        setFormData({ ...formData, phone: value });
                        if (value.trim() !== "") {
                          setErrors((prev) => ({ ...prev, phone: "" }));
                        }
                      }
                    }}
                    isInvalid={!!errors.phone}
                    className={`rounded-2 bg-light border shadow-sm fw-normal ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                    style={{
                      fontWeight: "400",
                    }}
                  />
                </InputGroup>

                {errors.phone && (
                  <div className="text-danger mt-1">{errors.phone}</div>
                )}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  <strong className="fw-normal">{t("h_text7")} </strong>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={`${t("h_text7")}...`}
                  value={formData.company_name}
                  onChange={(e) => {
                    setFormData({ ...formData, company_name: e.target.value });
                  }}
                  className={`rounded-2 bg-light border shadow-sm fw-normal ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                  style={{
                    fontWeight: "400",
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>
                  <strong
                    className={`fw-normal ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                  >
                    {t("h_text8")}
                  </strong>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={`${t("h_text8")}...`}
                  value={formData.position}
                  onChange={(e) => {
                    setFormData({ ...formData, position: e.target.value });
                  }}
                  className={`rounded-2 bg-light border shadow-sm fw-normal ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                  style={{
                    fontWeight: "400",
                  }}
                />
              </Form.Group>

              <Form.Group
                className={`mb-3 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              >
                <Form.Label>
                  <strong className="fw-normal">
                    {t("h_text9")} <span className="text-danger">*</span>
                  </strong>
                </Form.Label>
                {/* <Form.Control
                  as="textarea"
                  rows={5}
                  placeholder="Text here..."
                  className="dishcek-font  rounded-2 bg-light border shadow-sm fw-bold"
                /> */}
                <Form.Control
                  as="textarea"
                  rows={5}
                  placeholder={`${t("h_text10")}...`}
                  value={formData.message}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormData({ ...formData, message: value });
                    if (value.trim() !== "") {
                      setErrors((prev) => ({ ...prev, message: "" }));
                    }
                  }}
                  isInvalid={!!errors.message}
                  className={`rounded-2 bg-light border shadow-sm fw-normal ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                  style={{
                    height: "7.5em",
                    overflowY: "auto",
                    resize: "none",
                    lineHeight: "1.5em",
                    fontWeight: "400",
                  }}
                />
                {errors.message && (
                  <div className="text-danger mt-1">{errors.message}</div>
                )}
              </Form.Group>
              <button
                className={`btn btn-base fw-bold me-2 mt-3 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                onClick={handleSubmit}
                disabled={
                  !formData.name.trim() ||
                  !formData.email.trim() ||
                  !isValidEmail(formData.email) ||
                  !formData.phone.trim() ||
                  !formData.message.trim()
                }
              >
                {t("new_text_1")} <MdArrowOutward fontSize={20} />
              </button>
            </Form>
          </div>
        </div>
      </div>

      {/* Want To Hire */}
      <div
        className="inter-font container top want-hire p-4 d-flex justify-content-center align-items-center position-relative text-white "
        style={{
          backgroundColor: "#411318",
          minHeight: "404px",
          flexDirection: "column",
          // height: "405px",
          borderRadius: "40px",
          marginBottom: "50px",
        }}
        id="places"
      >
        <div
          className={`inter-font text-center w-100 mt-5 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
          style={{
            // padding: "2rem",
            minHeight: "auto",
            justifyContent: "center",
            maxWidth: "525px",
          }}
        >
          <h1
            className={`fw-normal display-6 d-md-none ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
            style={{
              maxWidth: "525px",
              fontWeight: "400px",
              fontSize: "50px",
            }}
          >
            {t("h_s6_title")}
          </h1>
          <h1
            className={`fw-normal display-3 d-none d-md-block ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
            style={{
              fontWeight: "400px",
              fontSize: "50px",
            }}
          >
            {t("h_s6_title")}
          </h1>
        </div>

        <button
          className={`btn btn-base fw-bold me-2 mt-3 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
          onClick={() => navigate("/company")}
        >
          {t("h_s6_btn")} <MdArrowOutward fontSize={20} />
        </button>
        <div className="inter-font design-i">
          <img src={design} />
        </div>

        <div className="inter-font talents">
          <img src={person1} className="inter-font person1" />
          <img src={person2} className="inter-font person2" />
          <img src={person3} className="inter-font person3" />
        </div>
        {/* <div className="inter-font hireTalents">
          <img src={person5} className="inter-font person1" />
          <img src={person5} className="inter-font person2" />
          <img src={person6} className="inter-font person3" />
        </div> */}
      </div>

      <Footer />
      {showPopup && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25 zindex"
          style={{ backdropFilter: "blur(2px)" }}
          onClick={onClose}
        >
          <div
            className="bg-white text-center p-4 rounded-4 shadow"
            style={{
              maxWidth: 500,
              width: "90%",
              boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
              animation: "scaleIn 0.3s ease-out",
              direction: isRTL ? "rtl" : "ltr",
            }}
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
          >
            <div className="mb-3">
              <div
                className="mx-auto d-flex justify-content-center align-items-center"
                style={{
                  backgroundColor: "#32C769",
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  fill="white"
                  className="bi bi-check-lg"
                  viewBox="0 0 16 16"
                >
                  <path d="M13.485 1.929a.75.75 0 0 1 1.03 1.092l-8 9a.75.75 0 0 1-1.08.02l-4-4a.75.75 0 0 1 1.06-1.06l3.47 3.47 7.52-8.522z" />
                </svg>
              </div>
            </div>

            {/* Text */}
            <h5
              className={`fw-bold mb-2 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              style={{ fontWeight: 400 }}
            >
              {t("h_text1")} {/* "Thank You!" */}
            </h5>
            <p
              className={`text-secondary mb-4 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              style={{ fontSize: 14, fontWeight: 400 }}
            >
              {t("h_text2")}{" "}
              {/* "Your request has been received. You will also get a confirmation email shortly with our thanks." */}
            </p>

            {/* Button */}
            <button
              className={`border-0 text-white fw-medium px-5 py-2 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              style={{
                backgroundColor: "#FF5C35",
                borderRadius: "999px",
                fontSize: 16,
                fontWeight: 400,
              }}
              onClick={onClose}
            >
              {t("c_t_close")} {/* "Close" */}
            </button>
          </div>

          {/* Animation Styles */}
          <style>{`
    @keyframes scaleIn {
      from { transform: scale(0.9); opacity: 0; }
      to { transform: scale(1); opacity: 1; }
    }
  `}</style>
        </div>
      )}
    </div>
  );
};

export default HomePage;
